exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".teacher-avatar{position:relative;width:112px;height:112px;-webkit-border-radius:60px;-webkit-background-clip:padding-box;-moz-border-radius:60px;-moz-background-clip:padding;border-radius:60px;background-clip:padding-box;margin:7px 0 0 5px;background-size:cover;background-position:50%}.profile-img{overflow:initial!important}i.ivu-icon.ivu-icon-ios-close{position:relative;display:block;z-index:100;float:right;top:0;right:0;border-radius:100%;background:#fff;cursor:pointer;border:1px solid #d9232e;width:30px;height:30px;line-height:30px;text-align:center;color:#d9232e;font-weight:bolder;font-size:21px}i.ivu-icon.ivu-icon-ios-close:hover{color:#fb202d;border-color:#fb202d}i.ivu-icon.ivu-icon-ios-close:active{color:#bf131f;border-color:#bf131f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1985187a","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/fundraisers/components/show/FundraiserProfile.vue
// module id = 195
// module chunks = 0